import React, { useState } from 'react';
import { Card, Form, Input, Switch, Button, Select, InputNumber, message, Divider, Alert, Space } from 'antd';
import { SaveOutlined, ReloadOutlined, SecurityScanOutlined } from '@ant-design/icons';

const { Option } = Select;
const { TextArea } = Input;

const SystemSettings: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSave = async (values: any) => {
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      message.success('系统设置保存成功！');
    } catch (error) {
      message.error('保存失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
    message.info('已重置为默认设置');
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="系统设置">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          initialValues={{
            sessionTimeout: 120,
            passwordMinLength: 8,
            enableAuditLog: true,
            enableTwoFactor: false,
            maxLoginAttempts: 5,
            lockoutDuration: 30,
            enableEmailNotification: true,
            enableSmsNotification: false,
            backupFrequency: 'daily',
            logRetentionDays: 90,
            systemName: 'AI智能机器人管理系统',
            systemDescription: '基于AI技术的智能机器人后台管理系统',
            contactEmail: 'admin@example.com',
            contactPhone: '400-123-4567'
          }}
        >
          <Card title="安全设置" size="small" style={{ marginBottom: 16 }}>
            <Form.Item
              label="会话超时时间（分钟）"
              name="sessionTimeout"
              tooltip="用户无操作后自动登出的时间"
            >
              <InputNumber min={5} max={480} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
              label="密码最小长度"
              name="passwordMinLength"
              tooltip="用户密码的最小字符数"
            >
              <InputNumber min={6} max={20} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
              label="启用操作审计日志"
              name="enableAuditLog"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              label="启用二次验证"
              name="enableTwoFactor"
              valuePropName="checked"
              tooltip="敏感操作需要二次确认"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              label="最大登录尝试次数"
              name="maxLoginAttempts"
              tooltip="超过此次数将锁定账户"
            >
              <InputNumber min={3} max={10} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
              label="账户锁定时间（分钟）"
              name="lockoutDuration"
              tooltip="登录失败后账户锁定的时间"
            >
              <InputNumber min={5} max={1440} style={{ width: '100%' }} />
            </Form.Item>
          </Card>

          <Card title="通知设置" size="small" style={{ marginBottom: 16 }}>
            <Form.Item
              label="启用邮件通知"
              name="enableEmailNotification"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              label="启用短信通知"
              name="enableSmsNotification"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              label="备份频率"
              name="backupFrequency"
              tooltip="系统数据自动备份的频率"
            >
              <Select>
                <Option value="hourly">每小时</Option>
                <Option value="daily">每天</Option>
                <Option value="weekly">每周</Option>
                <Option value="monthly">每月</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="日志保留天数"
              name="logRetentionDays"
              tooltip="操作日志的保留时间"
            >
              <InputNumber min={7} max={365} style={{ width: '100%' }} />
            </Form.Item>
          </Card>

          <Card title="系统信息" size="small" style={{ marginBottom: 16 }}>
            <Form.Item
              label="系统名称"
              name="systemName"
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="系统描述"
              name="systemDescription"
            >
              <TextArea rows={3} />
            </Form.Item>

            <Form.Item
              label="联系邮箱"
              name="contactEmail"
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="联系电话"
              name="contactPhone"
            >
              <Input />
            </Form.Item>
          </Card>

          <Divider />

          <Alert
            message="安全提示"
            description="修改安全设置后，建议通知所有用户重新登录以确保设置生效。"
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
          />

          <Form.Item>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
                loading={loading}
              >
                保存设置
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={handleReset}
              >
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default SystemSettings;
